// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__msKsj","sticky":"Nav_sticky__WLKKn","linkActive":"Nav_linkActive__LJ4k7","link":"Nav_link__Yl3Bc","line":"Nav_line__s65uR","logo":"Nav_logo__gcnvh"};